import { render, staticRenderFns } from "./ChatNotification.vue?vue&type=template&id=edd28ebe&scoped=true"
import script from "./ChatNotification.vue?vue&type=script&lang=js"
export * from "./ChatNotification.vue?vue&type=script&lang=js"
import style0 from "./ChatNotification.vue?vue&type=style&index=0&id=edd28ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd28ebe",
  null
  
)

export default component.exports